import './MovieAbout.scss'
import { useParams } from 'react-router-dom'
import { movieApi } from '../../redux/services/movieApi'
import { LoaderAboutMovie } from '../../ui/LoaderAboutMovie/LoaderAboutMovie'

export const MovieAbout = () => {

    const { movieId } = useParams()
    const id = Number(movieId)
    const { data: movie, isLoading, error, refetch } = movieApi.useFetchIdMovieQuery(id)

    function hasNoData(objValue: string | number) {
        return objValue === null || '' ? 'нет данных' : objValue
    }

    return (
        <section className='movie-about'>
            <div className="container">
                {isLoading && <LoaderAboutMovie />}
                {error &&
                    <div>
                        <h2 style={{ marginBottom: "10px" }}> Произошла ошибка</h2> <button className='btn btn-dark' onClick={() => refetch()}>Обновить список</button>
                    </div>}
                {movie &&
                    <div className="movie-about__container">
                        <h2 className='title-min'>О фильме</h2>
                        <div className="movie-props">
                            <ul className="movie-props__list">
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Язык оригинала
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {hasNoData(movie.language)}
                                    </span>
                                </li>
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Бюджет
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {movie.budget ? `${movie.budget} долл.США` : 'нет данных'}
                                    </span>
                                </li>
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Выручка
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {movie.budget ? `${movie.budget} долл.США` : 'нет данных'}
                                    </span>
                                </li>
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Режиссёр
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {hasNoData(movie.director)}
                                    </span>
                                </li>
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Продакшен
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {hasNoData(movie.production)}
                                    </span>
                                </li>
                                <li className="movie-props__item">
                                    <span className="movie-props__title">
                                        Награды
                                    </span>
                                    <span className="movie-props__dot">
                                    </span>
                                    <span className="movie-props__name">
                                        {hasNoData(movie.awardsSummary)}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                }
            </div>
        </section>




    )
}